import React, { useContext } from 'react';
import { compose } from 'redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { LoginRequired } from '../hoc/LoginRequired.jsx';
import { Page } from '../hoc/Page.jsx';

import { LangContext } from '../App.jsx';
import { CABINET_SLUG, getDepartmentChildren } from '../../config';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


const DepartmentComponent = ({ is_moderator, is_staff, is_teacher,
                               yandex_saved_payment, paypal_subscription }) => {
  let location = useLocation();
  const lang = useContext(LangContext);
  const params = location.pathname.split('/').filter(i => ![lang, CABINET_SLUG, ''].includes(i));
  let list = [];
  if (params.length){
    const findParam = params[0];
    let tree = getDepartmentChildren(findParam);
    const root = '/' + lang + '/' + CABINET_SLUG + '/' + findParam + '/';
    if (tree) {
      for (const [key, value] of Object.entries(tree)) {
        let item = <p key={key}><Link to={root + key + '/'}>{value['title']}</Link></p>;

        if (value.is_moderator) {
          if (is_moderator) list.push(item);
          continue;
        }
        if (value.is_staff) {
          if (is_staff) list.push(item);
          continue;
        }
        if (value.is_teacher) {
          if (is_teacher) list.push(item);
          continue;
        }
        if (value.yandex_saved_payment) {
          if (yandex_saved_payment) list.push(item);
          continue;
        }
        if (value.paypal_subscription) {
          if (paypal_subscription) list.push(item);
          continue;
        }
        list.push(item);
      }
    }
  }
  return <div>{ list }</div>
}

DepartmentComponent.propTypes = {
  is_moderator: PropTypes.bool.isRequired,
  is_staff: PropTypes.bool.isRequired,
  is_teacher: PropTypes.bool.isRequired,
  yandex_saved_payment: PropTypes.bool.isRequired,
  paypal_subscription: PropTypes.bool.isRequired,
}

let mapStateToProps = (state) => {
  return {
    is_moderator: state.auth.is_moderator,
    is_staff: state.auth.is_staff,
    is_teacher: state.auth.is_teacher,
    yandex_saved_payment: state.auth.yandex_saved_payment,
    paypal_subscription: state.auth.paypal_subscription,
  }
};

export default compose(
  connect(mapStateToProps),
  LoginRequired,
  Page
)(DepartmentComponent);

